package dk.smark.demo.location

import kotlin.coroutines.suspendCoroutine
import kotlinx.browser.window
import kotlin.coroutines.resume

class JsShareService : ShareService {

    override fun isSupported(): Boolean =
        js("typeof navigator.share === 'function'") as Boolean

    override suspend fun shareLocation(location: GenericLocation) {
        val googleMapsUrl = buildGoogleMapsUrl(location)
        val osmUrl = buildOsmUrl(location)

        suspendCoroutine { continuation ->
            val shareData = js("{}")
            shareData["title"] = "My Location"
            shareData["text"] = "Here is my current location:\n"+
                    "\nGoogle Maps: \n$googleMapsUrl\n\nOSM: \n$osmUrl\n" +
                    "\nGeo URI: \ngeo:${location.latitude},${location.longitude}\n\n"
                    shareData["url"] = googleMapsUrl

            window.navigator.asDynamic().share(shareData)
                .then({ continuation.resume(Unit) })
                .catch({ continuation.resume(Unit) })
        }
    }

    private fun buildGoogleMapsUrl(location: GenericLocation): String {
        return "https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}"
    }

    private fun buildOsmUrl(location: GenericLocation): String {
        return "https://www.openstreetmap.org/?mlat=${location.latitude}&mlon=${location.longitude}#map=15/${location.latitude}/${location.longitude}"
    }
}

actual fun createShareService(): ShareService = JsShareService()